"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _query = _interopRequireDefault(require("./query.graphql"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var usersLogTable = function usersLogTable() {
  var view = {
    query: _query["default"],
    rowKey: 'username',
    isAscentOrder: true,
    handle: 'usersLog',
    columns: [{
      name: 'username',
      label: 'Username',
      filter: true,
      sort: true
    }, {
      name: 'firstName',
      label: 'First Name',
      filter: true,
      sort: true
    }, {
      name: 'lastName',
      label: 'Last Name',
      filter: true,
      sort: true
    }, {
      name: 'email',
      label: 'Email',
      filter: true,
      sort: true
    }, {
      name: 'lastLoginAt',
      label: 'Last Login',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'pawns',
      label: 'Pawns',
      filter: false,
      sort: false,
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row,
          isCsv = _ref.isCsv;
        var pawns = row.pawnList.map(function (p) {
          return p.pawn.label + (p.pawn.archived ? ' (ARCHIVED)' : '');
        });
        if (isCsv) {
          return pawns.join();
        }
        return pawns.map(function (p, index) {
          return /*#__PURE__*/_react["default"].createElement("ul", {
            style: {
              paddingLeft: '1.0em'
            },
            key: index
          }, /*#__PURE__*/_react["default"].createElement("li", null, p));
        });
      }
    }, {
      name: 'metrics',
      label: 'Data Collection Waves',
      filter: false,
      sort: false,
      render: function render(_ref2) {
        var value = _ref2.value,
          row = _ref2.row,
          isCsv = _ref2.isCsv;
        var deployments = [];
        row.pawnList.forEach(function (p) {
          p.assignmentProgressList.forEach(function (ap) {
            if (ap.assignment.group.group.groupId && ap.assignment.assignmentId) {
              deployments.push(ap.assignment.group.group.label + ' 〉' + ap.assignment.label + ' 〉' + ap.deployment.label);
            }
          });
        });
        if (isCsv) {
          return deployments.join();
        }
        return deployments.map(function (d, index) {
          return /*#__PURE__*/_react["default"].createElement("ul", {
            style: {
              paddingLeft: '1.0em'
            },
            key: index
          }, /*#__PURE__*/_react["default"].createElement("li", null, d));
        });
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "usersLog",
    saveState: true,
    views: [{
      handle: 'usersLog',
      title: 'Users Log',
      table: view
    }]
  }));
};
var _default = exports["default"] = {
  name: 'userslog',
  title: 'Users Log',
  content: usersLogTable()
};